import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { useRouter, useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'languageButton',
  setup(__props) {

const router = useRouter()
const route = useRoute()

function toggleLocale() {
    const currentName = route.name as string

    const targetName = currentName.includes('-en') ? currentName.replace('-en', '') : `${currentName}-en`
    if (targetName) {
        // Manual push history state because default forgets hash for some reason:
        window.history.pushState(null, '', window.location.href)
        // Use router.replace instead of router.push to prevent duplicate history entries:
        router.replace({ name: targetName, hash: window.location.hash })
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "language-button",
    onClick: toggleLocale
  }, [
    _createElementVNode("img", {
      class: "icon",
      src: require('@/icons/globe.png'),
      alt: "Language globe icon",
      width: "22",
      height: "22"
    }, null, 8, _hoisted_1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})